<template>
  <v-row>
    <div
      v-if="description"
      v-html="description"
      class="description"
    />
    <ValidationProvider
      :name="field.name"
      :rules="countryRules"
      slim
      mode="eager"
      v-slot="{ errors }"
    >
      <v-autocomplete
        v-model="model"
        :items="countries"
        :label="`${placeholder} ${requiredHint}`"
        :disabled="disabled"
        :no-data-text="$t('empty')"
        :error-messages="errors[0]"
      >
        <template v-slot:selection="data">
          <div class="d-flex align-center pa-0 ml-n3">
            <country-flag
              :country="data.item.value"
              :style="{ margin: 0 }"
            />
            <span>
              {{ data.item.text }}
            </span>
          </div>
        </template>
        <template v-slot:item="data">
          <div class="d-flex align-center pa-0 ml-n3">
            <country-flag
              :country="data.item.value"
              :style="{ margin: 0 }"
            />
            <span>
              {{ data.item.text }}
            </span>
          </div>
        </template>
      </v-autocomplete>
    </ValidationProvider>
  </v-row>
</template>

<script>
import _ from 'lodash'
import CountryFlag from 'vue-country-flag'
import {getAllCountries} from '@/locales/i18n'

export default {
  components: {
    CountryFlag,
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    customProps: {
      type: Object,
      default: () => {}
    },
    value: {
      type: String,
      default: ''
    },
    emitOnlyCountryCode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: '',
      allCountries: [],
    }
  },
  computed: {
    countries() {
      if (_.isEmpty(this.allowedCountryCodes)) {
        return this.allCountries
      }

      if (!_.isEmpty(this.allCountries)) {
        return this.allCountries.filter((country) => {
          return this.allowedCountryCodes.find((code) => {
            return code.toUpperCase() === country.value.toUpperCase()
          })
        })
      }

      return []
    },
    allowedCountryCodes() {
      return _.get(this.customProps, 'allowedCountryCodes', [])
    },
    placeholder() {
      return _.get(this.field, 'placeholder', '')
        ? this.$t(_.get(this.field, 'placeholder', ''))
        : _.get(this.field, 'name', '')
    },
    requiredHint() {
      return _.get(this.field, 'required', false) ? '*' : ''
    },
    description() {
      const fieldDescription =
        _.get(this.field, 'metadata.description', '') ||
        _.get(this.field, 'description', '')

      if (!_.isEmpty(fieldDescription)) {
        return fieldDescription
      }

      return ''
    },
    disabled() {
      return _.get(this.field, 'disabled', false)
    },
    countryRules() {
      const required =
        _.get(this.field, 'required', false) ? 'required' : ''
      const fieldRules = _.get(this.field, 'rules', '')

      return [required, fieldRules]
        .filter(Boolean)
        .toString()
        .replace(/,/g, '|')
    },
  },
    watch: {
    model(newVal) {
      if (this.emitOnlyCountryCode) {
        this.$emit('input', newVal)
      } else {
        this.$emit('input', {
          key: _.get(this.field, 'key', ''),
          value: newVal,
          identity: _.get(this.field, 'identity', false)
        })
      }
    },
  },
  async created() {
    await this.getCountries()

    if (this.value) {
      this.model = this.value
    }
  },
  methods: {
    async getCountries() {
      try {
        const countries = await getAllCountries(this.$i18n.locale)
        this.allCountries = countries
      } catch (error) {
        console.log('Countries could not be loaded', error)
      }
    }
  },
}
</script>

<style lang="scss" scoped></style>
